<template>
  <transition name="layer">
    <div class="agree_layer" v-if="state !== 0">
      <div class="layer_deco">
        <div class="layer">
          <template v-if="state === 1">
            <div class="layer-header">
              <h1>개인정보 수집 및 이용 동의</h1>
            </div>
            <div class="contents">
              <p>(주) 넥슨코리아는 다음과 같이 개인정보를 수집 및 이용하고 있습니다.</p>
              <table>
                <colgroup>
                  <col width="31%" />
                  <col width="31%" />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>수집 및 이용 목적</th>
                    <th>항목</th>
                    <th>보유 및 이용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>출금 정보 등록, 포인트 전환</td>
                    <td>이름, 생년월일, 주소, 핸드폰 번호, 계좌정보 (예금주 이름, 은행명, 계좌번호)</td>
                    <td>
                      <strong
                        >회원탈퇴 또는 리워드포인트 서비스 종료 시까지 (법령에 특별한 규정이 있을 경우 관련 법령에 따라
                        보관)</strong
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>동의를 거부할 권리가 있으며, 동의를 거부할 경우 포인트 전환 금액 입금이 불가능 합니다.</p>
              <p>※ 그 외 사항은 개인정보 처리방침을 따릅니다.</p>
            </div>
          </template>

          <template v-if="state === 2">
            <div class="layer-header">
              <h1>고유식별정보 수집 및 이용 동의</h1>
            </div>
            <div class="contents">
              <p>㈜넥슨코리아는 다음과 같이 개인정보를 수집 및 이용하고 있습니다.</p>
              <table>
                <colgroup>
                  <col width="31%" />
                  <col width="31%" />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>수집 및 이용 목적</th>
                    <th>항목</th>
                    <th>보유 및 이용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>제세공과금 처리</td>
                    <td>주민등록번호</td>
                    <td>
                      <strong
                        >회원탈퇴 또는 리워드포인트 서비스 종료 시까지 (법령에 특별한 규정이 있을 경우 관련 법령에 따라
                        보관)</strong
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>동의를 거부할 권리가 있으며, 동의를 거부할 경우 포인트 전환 금액 입금이 불가능 합니다.</p>
            </div>
          </template>

          <template v-if="state === 3">
            <div class="layer-header">
              <h1>개인정보 수집 및 이용 안내</h1>
            </div>
            <div class="contents">
              <p>
                ㈜넥슨코리아는 제세공과금 처리를 위해 다음과 같이 개인정보를 수집 및 이용하고 있으며, 관계 법령에 따른
                처리, 보관 완료 후 안전하게 삭제합니다.
              </p>
              <table>
                <colgroup>
                  <col width="45%" />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>처리의 법적 근거</th>
                    <th>항목</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>소득세법 제21조, 제127조, 제164조</td>
                    <td>이름, 주소, 주민등록번호, 휴대전화번호</td>
                  </tr>
                </tbody>
              </table>
              <p>동의를 거부할 권리가 있으며, 동의를 거부할 경우 포인트 전환 금액 입금이 불가능 합니다.</p>
              <p>※ 그 외 사항은 개인정보 처리방침을 따릅니다.​</p>
            </div>
          </template>

          <template v-if="state === 4">
            <div class="layer-header">
              <h1>개인정보 수집 및 이용 동의​</h1>
            </div>
            <div class="contents">
              <p>㈜넥슨코리아는 다음과 같이 개인정보를 수집 및 이용하고 있습니다.</p>
              <table>
                <colgroup>
                  <col width="31%" />
                  <col width="31%" />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>수집 및 이용 목적</th>
                    <th>항목</th>
                    <th>보유 및 이용기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>출금 정보 등록, 포인트 전환</td>
                    <td>이름, 생년월일, 주소, 핸드폰 번호, 계좌정보 (예금주 이름, 은행명, 계좌번호)</td>
                    <td>
                      <strong
                        >회원탈퇴 또는 리워드포인트 서비스 종료 시까지 (법령에 특별한 규정이 있을 경우 관련 법령에 따라
                        보관)</strong
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <p>동의를 거부할 권리가 있으며, 동의를 거부할 경우 포인트 전환 금액 입금이 불가능 합니다.</p>
              <p>※ 그 외 사항은 개인정보 처리방침을 따릅니다.​</p>
            </div>
          </template>

          <template v-if="state === 5">
            <div class="layer-header">
              <h1>개인정보 수집 및 이용 안내</h1>
            </div>
            <div class="contents">
              <p>
                ㈜넥슨코리아는 제세공과금 처리를 위해 다음과 같이 개인정보를 수집 및 이용하고 있으며, 관계 법령에 따른
                처리, 보관 완료 후 안전하게 삭제합니다.
              </p>
              <table>
                <colgroup>
                  <col width="45%" />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th>처리의 법적 근거</th>
                    <th>항목</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>소득세법 제21조, 제127조, 제164조</td>
                    <td>이름, 주소, 주민등록번호, 휴대전화번호</td>
                  </tr>
                </tbody>
              </table>
              <p>동의를 거부할 권리가 있으며, 동의를 거부할 경우 포인트 전환 금액 입금이 불가능 합니다.</p>
              <p>※ 그 외 사항은 개인정보 처리방침을 따릅니다.​</p>
            </div>
          </template>
          <div class="bt">
            <v-button @handleClick="handleClick" class="btn_close2" :textHide="true" text="닫기" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import VButton from '@/components/atoms/VButton';

export default {
  components: {
    VButton,
  },
  props: {
    state: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleClick() {
      this.$emit('custom-change');
    },
  },
};
</script>

iOS 수직정렬 대응하여 임시로 별도 처리함. 레이어 수직정렬 전반적으로 개편 필요
<style scoped lang="scss">
.agree_layer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  .layer-header {
    h1 {
      padding: 21px 0 0 30px;
      font: 16px 'NEXONLv1Gothic';
      color: #ffffff;
    }
  }
}
</style>
